function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighLatency = function SvgHighLatency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24mm",
    height: "24mm",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M21.258.741h6.37v30.731h-6.37zM12.62 14.768h6.37v16.725h-6.37zM4.096 20.921h6.37v10.592h-6.37z",
    style: {
      strokeWidth: 0.215221,
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M3.15 4.283 5.404.335 7.66-3.612 9.95.315l2.291 3.927-4.546.02Z",
    style: {
      strokeWidth: 0.215221,
      fill: "currentColor"
    },
    transform: "matrix(1.48782 0 0 1.70902 -4.284 6.537)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.55448 0 0 .64473 -19.472 -6.704)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 29
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#fff"
    }
  }, "!"))));
};
export default SvgHighLatency;